import { HestiaIframeEvent, HestiaIframeTarget } from './hestiaIframeEvents'

interface HestiaIframeRelayRoute {
  event: HestiaIframeEvent
  source: HestiaIframeTarget
  target: HestiaIframeTarget
}

export const isHestiaIframeRelayRouteAllowed = ({
  event,
  source,
  target,
}: HestiaIframeRelayRoute): boolean => {
  return (
    source === HestiaIframeTarget.OwnerAgentWidget &&
    target === HestiaIframeTarget.WebsiteBuilder &&
    event === HestiaIframeEvent.WebsitePreviewReload
  )
}
